import { render, staticRenderFns } from "./recipient-info.vue?vue&type=template&id=885fa90c"
import script from "./recipient-info.vue?vue&type=script&lang=js"
export * from "./recipient-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports